import { CompleteSystemCCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const CompleteSystemCCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case CompleteSystemCCActionType.CompleteSystemCC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default CompleteSystemCCReducer
